import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

/**
 * Telas compartilhadas pelos dois canais (Integração WhatsApp, Conversas).
 * É o que desacopla WhatsApp de IA: antes tudo isso exigia ai_enabled.
 */
@Injectable({
  providedIn: 'root',
})
export class AiOrWhatsappEnabledGuard implements CanActivate, CanActivateChild {

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const user = this.authService.getUser();

    if (!user || (!user.ai_enabled && !user.whatsapp_enabled)) {
      this.router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
